import React from "react";
import Layout from "./../components/Layout/Layout";
import Home from "./Home";

const Pagenotfound = () => {
  return (
    <Home/>
  );
};

export default Pagenotfound;
